import { Injectable } from '@angular/core';
import { PouchdbService } from '../shared/pouchDb.service';
import { Constants } from '../shared/models/constants'
import { BookData } from '../shared/models/bookData';
import { ShelfValues, bookCategoeyEnums } from '../shared/models/shelfEnums';
import { Page } from '../shared/models/page';
import { Book } from '../shared/models/book';
import { Subject } from 'rxjs';
import { PageContent } from '../shared/models/pageContent';
import { LiquidModel } from '../shared/models/liquidModel';
import { PageTemplates } from '../shared/models/pageTemplates';
import { IS_ElectronService } from '../shared/IS_Electron.service';
import { MatSnackBar } from '@angular/material';


@Injectable()
export class EBEpouchdbService {
    notesDataebe: Subject<any> = new Subject();
    notesDataebe$ = this.notesDataebe.asObservable();
    localDB; remoteDB;
    bookDataObj: BookData = new BookData();
    // bookData: Subject<any> = new Subject();
    // bookData$ = this.bookData.asObservable();
    // pageContentData: Subject<any> = new Subject();
    // pageContentData$ = this.pageContentData.asObservable();
    constructor(public pouchService: PouchdbService, private ElectronService: IS_ElectronService, public snackBar: MatSnackBar) {
        this.localDB = pouchService.localDB;


    }

    // getBookData(data) {
    //     this.bookData.next(data);

    // }

    updatenoteobj(bookObj, scope) {

        var self = this;
        //
        this.pouchService.localDB.find({
            selector: { type: 'bookData', _id: bookObj._id },
        }).then(function (result) {
            if (result.docs.length > 0) {

                bookObj._rev = result.docs[0]._rev;
                result.docs[0] = bookObj;

                return self.pouchService.localDB.put(result.docs[0]).then(function (response) {
                    console.log(response);
                    // self.getPages(bookObj,"","");
                    scope.viewnotescreen();

                }).catch(function (err) {
                    console.log(err);
                });

            }
        }).catch(function (err) {

        });
    }

    async updateBookObj(bookObj) {
        var self = this;
        //
        this.pouchService.localDB.find({
            selector: { type: 'book', _id: bookObj._id },
        }).then(async function (result) {
            if (result.docs.length > 0) {

                result.docs[0].pageCount = bookObj.pageCount;

                return await self.pouchService.localDB.put(result.docs[0]).then(function (response) {

                }).catch(function (err) {
                    console.log(err);
                });

            }
        }).catch(function (err) {

        });

    }

    savenote() {

        this.notesDataebe.next();
    }


    async updateBookDataObj(bookDataObj, scope) {

        var self = this;
        this.pouchService.localDB.find({
            selector: { type: 'bookData', _id: bookDataObj._id },
        }).then(async function (result) {
            if (result.docs.length > 0) {
                bookDataObj._rev = result.docs[0]._rev;
                result.docs[0] = bookDataObj;

                return await self.pouchService.localDB.put(result.docs[0]).then(async function (response) {
                    console.log(response);
                    // self.getPages(bookObj,"","");
                    if (scope)
                        await scope.loadEnrichmentsTab();

                }).catch(function (err) {
                    console.log(err);
                });

            }
        }).catch(function (err) {

        });

    }



    async createPageContentDoc(pageContent, scope) {

        var self = this;

        await self.pouchService.localDB.put(pageContent).then(async function (result) {

            await scope.setPageConent(pageContent);

        }).catch(function (err) {
            console.log(err);
        })
    }
    // getPageContentData(data) {
    //     this.pageContentData.next(data);

    // }
    getPageContent(id, scope) {
        var self = this;
        this.pouchService.localDB.find({
            selector: { type: 'pageContent', _id: id },
        }).then(function (result) {
            if (result.docs.length > 0) {
                if (scope)
                    scope.setPageConent(result.docs[0]);
                else
                    return result.docs[0];
            }
        }).catch(function (err) {

        });
    }
    /////////For MiniBook Creations start///////////////
    createNewMiniBook(obj) {
        var book = this.setMiniBook(obj, obj.thumbs.length);
        var self = this;

        this.pouchService.localDB.put(book).then(function (result) {

            self.pouchService.localDB.find({
                selector: { type: 'shelf', category: ShelfValues.Creations },
            }).then(function (doc) {
                doc.docs[0].bookIds.push(result.id);
                return self.pouchService.localDB.put(doc.docs[0]);
            }).then(function (response) {
                self.updateMiniBookPages(book, obj.thumbs);

            }).catch(function (err) {
                console.log(err);
            });

        }).catch(function (err) {

        })
    }
    setMiniBook(obj, count) {
        var bookObj = new Book();
        bookObj.author = Constants.USER;
        bookObj.bookType = bookCategoeyEnums.Ebook;
        bookObj.templateId = obj.themeId;
        bookObj.bookCategory = ShelfValues.Creations;
        bookObj.title = obj.name;
        bookObj.owner = Constants.USER;
        bookObj.pageCount = count;
        bookObj.bId = Constants.getGUID();
        bookObj._id = Constants.USER + "." + Math.round(new Date().getTime() / 1000) + ".book";

        return bookObj;

    }
    updateMiniBookPages(bookObj, thumbs) {
        var _this = this;
        this.pouchService.localDB.find({
            selector: { type: 'bookData', _id: bookObj.bookDataDocId },
        }).then(function (result) {
            if (result.docs.length == 0) {

                _this.setMiniBookDataObj(bookObj, thumbs, bookObj.templateId);

                _this.bookDataObj.bookDocId = bookObj._id; //bookdata object bookdocid updated for minibook
                //put opearation
                _this.pouchService.localDB.put(_this.bookDataObj).then(function (response) {
                    // _this.getBookData(_this.bookDataObj);

                }).catch(function (err) {
                    console.log(err);
                });

                bookObj.bookDataDocId = _this.bookDataObj._id;

                _this.pouchService.localDB.put(bookObj).then(function (response) {
                    // parentScope.setDataObj(_this.bookDataObj);

                    _this.openSnackBar('Minibook created successfully', '');
                }).catch(function (err) {
                    console.log(err);
                });
            }
            else if (result.docs.length > 0) {
                _this.addMiniBookPages(bookObj, thumbs);

            }
        }).catch(function (err) {

        });

    }

    openSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
            duration: 2000,
        });
    }


    addMiniBookPages(bookObj, thumbs) {
        var _this = this;
        var pageContents = [];
        var bookDataObj = new BookData();
        this.pouchService.localDB.find({
            selector: { type: 'bookData', _id: bookObj.bookDataDocId },
        }).then(function (result) {
            if (result.docs.length > 0) {
                bookDataObj = result.docs[0];
                // var timestamp = Math.floor(Date.now() / 1000);
                var timestamp = Constants.getGUID();
                for (var j = 0; j < thumbs.length; j++) {
                    bookObj.pageCount = bookObj.pageCount + 1;
                    var page: Page = new Page();
                    //page.id = timestamp++;
                    page.id = Constants.getGUID();
                    page.pageNumber = bookObj.pageCount;
                    page.title = 'Page ' + page.pageNumber;
                    page.type = 'blankPage';;
                    var liquidModel: LiquidModel = new LiquidModel();
                    var pageContent: PageContent = new PageContent();
                    pageContent._id = Constants.USER + "." + page.id + ".pageContent";
                    liquidModel.pageBgStyle = { "type": "image", "url": thumbs[j].url, aspectRatio: true };
                    pageContent.pageContent = liquidModel;
                    pageContent.bookDocId = bookObj._id; //pagecontent bookDocId updated
                    page.contentDocId = pageContent._id;
                    page.isCustomBg = true; // for background image updated
                    pageContents.push(pageContent);
                    bookDataObj[page.id + ""] = page;
                    bookDataObj.pages.splice(bookDataObj.pages.length - 1, 0, page.id + "");
                }
                _this.updateBookObj(bookObj);
                _this.updateBookDataObj(bookDataObj, undefined);
                _this.createBookPagesContentDocs(pageContents);

                _this.openSnackBar('Added pages successfully', '');

            }
        }).catch(function (err) {

        });

    }
    setMiniBookDataObj(bookObj, thumbs, templateId) {
        if (!this.ElectronService.IS_ELECTRON)
            var bookTemplates = Constants.getTemplates();
        else
            var bookTemplates = Constants.getElectronTemplates();
        var templateObj = bookTemplates[templateId + ""];
        var pageContents = [];
        this.bookDataObj = new BookData();
        this.bookDataObj._id = Constants.USER + "." + bookObj.bId + ".bookData";
        // var timeStamp = Math.round(new Date().getTime() / 1000);
        var timeStamp = Constants.getGUID();
        for (var i = 1; i <= 3; i++) {
            var page: Page = new Page();
            // page.id = timeStamp++;
            page.id = Constants.getGUID();
            var liquidModel: LiquidModel = new LiquidModel();
            var pageContent: PageContent = new PageContent();
            pageContent._id = Constants.USER + "." + page.id + ".pageContent";
            pageContent.bookDocId = bookObj._id; //update pagecontent bookdocid
            if (i == 1) {
                liquidModel.pageBgStyle = { "type": "image", "url": templateObj.front_P, aspectRatio: true };
                pageContent.pageContent = liquidModel;
                page.contentDocId = pageContent._id;
                pageContents.push(pageContent);
                this.bookDataObj[page.id + ""] = page;
                this.bookDataObj.pages.push(page.id + "");
                this.bookDataObj.lastOpenedPage = page.id;
            }
            if (i == 2) {
                page.pageNumber = 1;
                for (var j = 0; j < thumbs.length; j++) {
                    var page: Page = new Page();
                    // page.id = timeStamp++;
                    page.id = Constants.getGUID();
                    page.pageNumber = j + 1;
                    page.title = 'Page ' + page.pageNumber;
                    page.type = 'blankPage';
                    var liquidModel: LiquidModel = new LiquidModel();
                    var pageContent: PageContent = new PageContent();
                    pageContent._id = Constants.USER + "." + page.id + ".pageContent";
                    pageContent.bookDocId = bookObj._id;//update pagecontent bookdocid
                    liquidModel.pageBgStyle = { "type": "image", "url": thumbs[j].url, aspectRatio: true };
                    pageContent.pageContent = liquidModel;
                    page.contentDocId = pageContent._id;
                    page.isCustomBg = true; // for background image updated
                    pageContents.push(pageContent);
                    this.bookDataObj[page.id + ""] = page;
                    this.bookDataObj.pages.push(page.id + "");
                }
            }
            if (i == 3) {
                liquidModel.pageBgStyle = { "type": "image", "url": templateObj.back_P, aspectRatio: true };
                pageContent.pageContent = liquidModel;
                page.contentDocId = pageContent._id;
                pageContents.push(pageContent);
                this.bookDataObj[page.id + ""] = page;
                this.bookDataObj.pages.push(page.id + "");
            }
        }
        this.createBookPagesContentDocs(pageContents);

    }
    createBookPagesContentDocs(pageContents) {
        var self = this;

        self.pouchService.localDB.bulkDocs(pageContents, function (err, response) {
            if (err) {
                return console.log(err);
            } else {
                console.log("Documents created Successfully");
            }


        }).then(function (result) {


        }).catch(function (err) {

        })
    }


    getCreationBooksData(parentThis, list) {

        this.pouchService.localDB.find({
            selector: { type: 'book', _id: { $in: list.bookIds } },
        }).then(function (result) {

            // parentThis.creationsBooksArr = result.docs;
            parentThis.updateCreationsBooks(result.docs);

        }).catch(function (err) {
        });
    }
    reOrderPages(bookDataObj, pages, index) {
        for (var i = 0; i < pages.length; i++) {
            var temp = pages[i].attributes.id.value;
            bookDataObj.pages.splice(i + 1, 1, pages[i].attributes.id.value);
            bookDataObj[pages[i].attributes.id.value].pageNumber = i + 1;
        }
        bookDataObj.lastOpenedPage = pages[index].attributes.id.value;
        this.updateBookDataObj(bookDataObj, undefined);
        return bookDataObj;
    }
    deletePage(pageObj, bookDataObj, bookObj) {
        var index = bookDataObj.pages.indexOf(pageObj.id);
        if (index > 0) {
            bookDataObj.pages.splice(index, 1);
            delete bookDataObj[pageObj.id];
            if (index == 1) {
                bookDataObj.lastOpenedPage = bookDataObj.pages[1];
            }
            else {
                bookDataObj.lastOpenedPage = bookDataObj.pages[index - 1];
            }
            // for (var i = 0; i < bookDataObj.pages.length; i++) {
            //     if (i != 0 && i != bookDataObj.pages.length - 1) {

            //         bookDataObj[bookDataObj.pages[i]].pageNumber = i;
            //         bookDataObj[bookDataObj.pages[i]].title = 'Page '+i;
            //     }
            // }

            bookObj.pageCount--;
            this.updateBookDataObj(bookDataObj, undefined);
            this.updateBookObj(bookObj);

            var self = this;
            self.pouchService.localDB.find({
                selector: { type: 'pageContent', _id: pageObj.contentDocId },
            }).then(function (doc) {
                if (doc.docs[0].length > 0)
                    return self.pouchService.localDB.remove(doc.docs[0]._id, doc.docs[0]._rev);
            }).then(function (result) {

            }).catch(function (err) {
                console.log(err);
            });
            return bookDataObj;

        }


    }
    createTemplate(pageTemplate) {
        var self = this;
        this.pouchService.localDB.put(pageTemplate).then(function (response) {
            self.pouchService.localDB.find({
                selector: { type: 'pageTemplates' },
            }).then(function (result) {
                if (result.docs.length == 0) {
                    var pageTemplates = self.setPageTemplate(pageTemplate);
                    self.pouchService.localDB.put(pageTemplates).then(function (response) {

                    }).catch(function (err) {

                    });

                }
                else if (result.docs.length > 0) {
                    result.docs[0].contentDocIds.push(pageTemplate._id);
                    self.pouchService.localDB.put(result.docs[0]).then(function (response) {

                    }).catch(function (err) {

                    });

                }
            }).catch(function (err) {

            });


        }).catch(function (err) {
            console.log(err);
        });
    }
    setPageTemplate(pageTemplate) {
        // var timestamp = Math.floor(Date.now() / 1000);
        var timestamp = Constants.getGUID();
        var pageTemplates: PageTemplates = new PageTemplates();
        pageTemplates.contentDocIds.push(pageTemplate._id);
        // pageTemplates._id = timestamp + '';
        return pageTemplates;
    }

    getTemplatePageContent(id) {
        var self = this;

        return new Promise((resolve, reject) => {
            self.pouchService.localDB.find({
                selector: { type: 'pageContent', _id: id },
            }).then(function (result) {
                if (result.docs.length > 0) {
                    resolve(result.docs[0]);
                }
            }).catch(function (err) {

            });
        });
    }



}



// WEBPACK FOOTER //
// ./src/app/EBE/EBEpouchdb.service.ts